import { render, staticRenderFns } from "./chatbotProperties.vue?vue&type=template&id=c36e4d32&scoped=true&"
import script from "./chatbotProperties.vue?vue&type=script&lang=js&"
export * from "./chatbotProperties.vue?vue&type=script&lang=js&"
import style0 from "./chatbotProperties.vue?vue&type=style&index=0&id=c36e4d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36e4d32",
  null
  
)

export default component.exports